import Button from "@components/ui/button";
import Input from "@components/ui/input";
import { IconPlus, IconX } from "@tabler/icons-react";
import { useState } from "react";

export const OrgIdList = ({
  label,
  ids,
  onAdd,
  onRemove,
}: {
  label: string;
  ids: string[];
  onAdd: (value: string) => void;
  onRemove: (index: number) => void;
}) => {
  const [draft, setDraft] = useState("");

  const commit = () => {
    if (!draft.trim()) return;
    onAdd(draft);
    setDraft("");
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-1.5">
      <span className="tw-font-sans tw-text-xs tw-font-medium tw-uppercase tw-tracking-wider tw-text-blue-500">
        {label}
      </span>
      <div className="tw-flex tw-flex-wrap tw-gap-1.5">
        {ids.map((id, index) => (
          <span
            key={id}
            className="tw-font-mono tw-inline-flex tw-items-center tw-gap-1 tw-rounded tw-bg-blue-50 tw-px-2 tw-py-0.5 tw-text-xs tw-text-blue"
          >
            {id}
            <button
              type="button"
              aria-label={`Remove ${id}`}
              onClick={() => onRemove(index)}
              className="tw-flex tw-items-center tw-text-blue-500 hover:tw-text-blue-800"
            >
              <IconX className="tw-size-3" />
            </button>
          </span>
        ))}
        {ids.length === 0 && (
          <span className="tw-font-sans tw-text-xs tw-text-blue-400">None</span>
        )}
      </div>
      <div className="tw-flex tw-items-center tw-gap-1.5">
        <Input
          type="text"
          value={draft}
          placeholder="org id…"
          size="sm"
          containerClassName="tw-flex-1"
          className="tw-font-mono"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commit();
            }
          }}
        />
        <Button type="button" variant="secondary" size="sm" onClick={commit}>
          <IconPlus className="tw-size-3.5" />
          Add
        </Button>
      </div>
    </div>
  );
};
